document.addEventListener("DOMContentLoaded", () => {
  setTimeout(function() {
    var Navswiper = new Swiper(".nav-item-list", {
      slidesPerView: 3.6,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        2300: {
          slidesPerView: 4.6,
          spaceBetween: 30,
        },
        1400: {
          slidesPerView: 3.6,
          spaceBetween: 30,
        },
        990: {
          slidesPerView: 2.6,
          spaceBetween: 15,
        },
        300: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },
    });
  }, 100)


  const $SecondaryNav = $(".secondary-nav-title");
  const $CloseBtn = $(".header__icon--menu");

  // 一级导航
  $(".details-first-menu").hover(
    function () {
      $(this).attr("open", "");
    },
    function () {
      $(this).removeAttr("open");
    }
  );

  // 二级导航
  $SecondaryNav.hover(function () {
    var $this = $(this)
    if (!($this.hasClass("active"))) {
      var $NavContent = $this.parents(".mega-menu__content")
      $this.parents(".mega-menu__list").find(".secondary-nav-title").removeClass("active");
      $this.addClass("active");
      $NavContent.find('.secondary-nav-item').removeClass("active");
      var index = $this.parents(".mega-menu__link").attr("index");
      $NavContent.find(`.secondary-nav-item[index='${index}']`).addClass("active");
    }
  });


  $(".menu-drawer_btn").on("click touchend", function (e) {
    $CloseBtn.trigger("click");
  });
});
